import { Component, OnInit } from '@angular/core';
import { TemplateService } from '../../shared/services/template.service';
import { AccessService } from '../../core/services/access.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { EfoOmtService } from '../../shared/services/omt.service';
import { EfoElevateService } from '../../shared/services/elevate.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
  searchModel: string;
  isCollapse: boolean;
  isOpen: boolean;
  searchActived = false;
  issueModal: boolean = false;
  creativeModal: boolean = false;
  saving: boolean = false;
  months = [
    { name: 'January' },
    { name: 'February' },
    { name: 'March' },
    { name: 'April' },
    { name: 'May' },
    { name: 'June' },
    { name: 'July' },
    { name: 'August' },
    { name: 'September' },
    { name: 'October' },
    { name: 'November' },
    { name: 'December' },
  ];

  selectedMonth: string = '';
  creativeNotes: any = {};

  public me: any;

  constructor(
    private tplSvc: TemplateService,
    public accessApi: AccessService,
    private router: Router,
    private _location: Location,
    public efoOmt: EfoOmtService,
    public efoElevate: EfoElevateService,
  ) {}

  ngOnInit(): void {
    this.tplSvc.isSideNavCollapseChanges.subscribe(
      (isCollapse) => (this.isCollapse = isCollapse),
    );
    this.tplSvc.isSidePanelOpenChanges.subscribe(
      (isOpen) => (this.isOpen = isOpen),
    );
    //this.me = this.accessApi.me;
    this.accessApi.me$.subscribe((me) => {
      this.me = me;
    });
  }

  toggleSideNavCollapse() {
    this.isCollapse = !this.isCollapse;
    this.tplSvc.toggleSideNavCollapse(this.isCollapse);
  }

  toggleSidePanelOpen() {
    this.isOpen = !this.isOpen;
    this.tplSvc.toggleSidePanelOpen(this.isOpen);
  }

  toggleSearch() {
    this.searchActived = !this.searchActived;
  }

  logout(e): void {
    e.preventDefault();
    this.accessApi.logout({}).subscribe((response) => {
      this.router.navigate(['/authentication/sign-in']);
    });
  }
  backClick(): void {
    this._location.back();
  }
  onMonthChange(event: any) {
    this.selectedMonth = event.name;
  }
  submit() {
    if (
      this.creativeNotes.dealer &&
      (this.creativeNotes.sales || this.creativeNotes.svc) &&
      this.creativeNotes.month &&
      this.creativeNotes?.notes?.length > 0
    ) {
      this.saving = true;
      this.efoElevate.creativeSpecifics(this.creativeNotes).subscribe((res) => {
        this.saving = false;
        alert('Email sent to Account Manager & Account Owner');

        // Clear the form content
        this.creativeNotes = {
          dealer: '',
          sales: false,
          svc: false,
          month: '',
          notes: '',
        };
      });
    } else {
      alert('One of the fields is not filled out');
    }
  }
}
